module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item')], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "border-radius": "20px 20px 0 0",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "header-cell-style": _vm.headerStyle,
      "cell-style": _vm.cellStyle
    },
    on: {
      "row-click": _vm.toDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sTemplateName",
      "label": "Template  Name",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "align": "center",
      "label": "Create Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sName",
      "align": "center",
      "label": "Create User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sTableName",
      "align": "center",
      "label": "Table Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.sSchema) + "." + _vm._s(scope.row.sTableName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nUploadCnt",
      "label": "Uploads",
      "align": "center"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "View Template",
      "visible": _vm.detailViewFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailViewFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "sTemplateName"
    }
  }, [_vm._v(_vm._s(_vm.form.sTemplateName))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema",
      "prop": "sSchemaName"
    }
  }, [_vm._v(_vm._s(_vm.form.sSchema))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Table Name",
      "prop": "sTemplateName"
    }
  }, [_vm._v(_vm._s(_vm.form.sTableName))]), _vm._v(" "), _vm._l((_vm.form.ziduanList), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Column Name.",
        "prop": "sSchemaName"
      }
    }, [_c('label', [_vm._v(_vm._s(item.sFieldName))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v("\n              " + _vm._s(item.sFieldType) + "\n              "), (item.sLen) ? _c('label', [_vm._v("(" + _vm._s(item.sLen) + ")")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.nPrimaryKey == 1) ? _c('label', [_vm._v("Primary Key")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.toConvit1(item.sIfnull, _vm.options3)))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.sIfnull == 1) ? [_c('label', [_vm._v(_vm._s(_vm.toConvit3(item.sIfcheckValue, _vm.options4)))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.sIfcheckValue == 1) ? _c('label', [_vm._v(_vm._s(_vm.toConvit2(item.sValueRange, _vm.options5)))]) : _c('label', [_vm._v(_vm._s(item.sValueRange))])] : _vm._e()], 2)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.doDownLoad
    }
  }, [_vm._v("Download Template")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailViewFlag = false;
        _vm.addTemplateFlag = true;
        _vm.detail.nTemplateId = _vm.form.nTemplateId;
      }
    }
  }, [_vm._v("\n            Upload Data\n          ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Upload Setting",
      "visible": _vm.addTemplateFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTemplateFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.detail,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File Name",
      "prop": "sFileName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "readonly": "",
      "disabled": "",
      "placeholder": "Please select file"
    },
    model: {
      value: (_vm.detail.sFileName),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sFileName", $$v)
      },
      expression: "detail.sFileName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "upload-button"
  }, [_vm._v("\n                Select\n                "), _c('input', {
    attrs: {
      "id": "files",
      "type": "file"
    },
    on: {
      "change": _vm.changeFile
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "File Format",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.detail.sFileFormat),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sFileFormat", $$v)
      },
      expression: "detail.sFileFormat"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.detail.sFileFormat == 'csv') ? _c('el-form-item', {
    attrs: {
      "label": "Delimiters",
      "prop": "sSchemaName"
    }
  }, [_vm._l((_vm.options2), function(item) {
    return _c('el-radio', {
      key: item.id,
      attrs: {
        "label": item.id
      },
      model: {
        value: (_vm.detail.sRadio),
        callback: function($$v) {
          _vm.$set(_vm.detail, "sRadio", $$v)
        },
        expression: "detail.sRadio"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), (_vm.detail.sRadio == 5) ? _c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.detail.sDelimiters),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sDelimiters", $$v)
      },
      expression: "detail.sDelimiters"
    }
  }) : _vm._e()], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTemplateFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("Confirm")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03514a1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/upload/template.vue
// module id = 659
// module chunks = 1